import { Locale } from '@enmon/commons';
import { csCZ } from 'containers/locales/cs_CZ';
import { enUs } from 'containers/locales/en_US';
import { plPL } from '../locales/pl_PL';
import { skSK } from '../locales/sk_SK';

export const ANTD_LOCALE_MAP = {
  [Locale.CS]: csCZ,
  [Locale.EN]: enUs,
  [Locale.PL]: plPL,
  [Locale.SK]: skSK,
} as const;

// TODO add MAP_LOCALE_TO_DECIMAL_SEPARATOR and MAP_LOCALE_TO_DATE_FORMATS
